import { emailValidator, nameValidator, passValidator, phoneValidator } from "../../utils/formsValidation";
import { FormElementModel } from "../../models/FormElementModel";

export const webUserTextFields = [
  { label: "E-mail", name: "email", validator: emailValidator(true) },
  { label: "Powtórz e-mail", name: "repeatEmail" },
  { label: "Hasło", name: "password", validator: passValidator(true), type: "password" },
  { label: "Powtórz hasło", name: "reapeatPassword", type: "password" },
  { label: "Imię", name: "firstName", validator: nameValidator(true) },
  { label: "Nazwisko", name: "lastName", validator: nameValidator(true) },
  { label: "Nr. telefonu", name: "phone", validator: phoneValidator(true) }
];

export const finalizeWebUserFields = (isInvoice: boolean, isCompanyInvoice: boolean): FormElementModel[] => [
  { label: "Imię", name: "firstName", validator: nameValidator(true) },
  { label: "Nazwisko", name: "lastName", validator: nameValidator(true) },
  { label: "E-mail", name: "email", validator: emailValidator(true) },
  { label: "Nr. telefonu", name: "phone", validator: phoneValidator(true) },
  isCompanyInvoice
    ? { label: "Nazwa firmy", name: "companyName", validator: nameValidator(true) }
    : ({} as FormElementModel),
  isCompanyInvoice ? { label: "NIP", name: "NIP", validator: nameValidator(true) } : ({} as FormElementModel),
  isInvoice ? { label: "Ulica", name: "street", validator: nameValidator(true) } : ({} as FormElementModel),
  isInvoice ? { label: "Numer domu", name: "houseNumber", validator: nameValidator(true) } : ({} as FormElementModel),
  isInvoice
    ? { label: "Numer mieszkania", name: "flatNumber", validator: nameValidator(true) }
    : ({} as FormElementModel),
  isInvoice ? { label: "Miejscowość", name: "city", validator: nameValidator(true) } : ({} as FormElementModel)
];
